import { combineReducers } from 'redux';
import articles, { defaultState as articlesDefaultState } from './articles/reducer';

export default combineReducers({ articles });

export const defaultState = {
	articles: articlesDefaultState,
} as const;
